/* eslint-disable eqeqeq */
import { useContext, useEffect, useState } from "react";
import KrFormContext, { EndangeredAreaDesignationCriteria, KrEndangeredAreaFormTypes, KrFormContextEndangeredAreaType, NavHeadingsKRTZEum } from "../../../../contexts/krFormContext";
import ButtonField from "../../../../components/buttonField/buttonField";
import { classNameBtn, iconPosition } from "../../../../components/shared/button/types/buttonProps";
import { styleFormFieldHalf, stylizationVerticalAlign, stylizationWrapper } from "../../../../components/shared/stylization";
import { ButtonFieldProps } from "../../../../components/buttonField/types/buttonFieldProps";
import { ReactComponent as addCircleIcon } from '../../../../icons/add_circle.svg';
import Table from "../../../../components/shared/table/table";
import { TableProps } from "../../../../components/shared/table/types/tableProps";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { HeadersTable } from "../../../../helpers/featureTableConstruct";
import TableActions from "../../../../components/shared/table/tableActions/tableActions";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import { GetOptions } from "../../../../helpers/prepareForSelect";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { notifyWarn } from "../../../../components/snackbar/snackbar";
import { FormSectionProps } from "./shared/types/formSectionProps";
import TableTextEditRow from "../../shared/ElaboratorsAndInstitutions/tableEdit/tableTextEditRow";
import { PatternType } from "../../../../contexts/types/card";
import { createConfigValidation, validation } from "../../../../helpers/validation/validation";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { checkIfMarkedForCommentFilter, fireAddCommentBtnOnClickForRow, getFieldRef, getFieldRefForRow, getItemRef, getKRDictFieldNameForRow, renderSectionCommentBtn } from "../../../../helpers/form";
import { KRTZFieldDict } from "../../shared/commentsSidebar/fieldDict";
import CollectiveLabelChip from "../../collectiveEditionView/components/collectiveLabelChip";
import TextAreaField from "../../../../components/textAreaField/textAreaField";
import SelectForTextField from "../../../../components/selectForTextField/selectForTextField";
import { TextAreaFieldProps } from "../../../../components/textAreaField/types/textAreaFieldProps";
import { SelectForTextFieldProps } from "../../../../components/selectForTextField/types/selectForTextFieldProps";

type TableRecord = {
    itemGlobalId?: string, //technical field
    main?: string,
    reason?: string
}

const MainCriterionForArea = (props: FormSectionProps) => {
    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextEndangeredAreaType;
    const [isForm, setIsForm] = useState<boolean>(false);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [tableRow, setTableRow] = useState<TableRecord>();
    const [visibilityRows, setVisibilityRows] = useState<string[]>([]);
    const [rowsToFoldOut, setRowsToFoldOut] = useState<string[]>([]);
    const [selectedDetailed, setSelectedDetailed] = useState<Option | undefined>();
    const defaultCriterion: EndangeredAreaDesignationCriteria = {
        kryT_WYZN_TZ_GLOWNE_ID: null,
        kryT_WYZN_TZ_SZCZEGOLOWE_ID: null,
        uzasadnienie: null
    };
    const [criterionRocord, setCriterionRocord] = useState<EndangeredAreaDesignationCriteria>(defaultCriterion);
    const [detailedCriteriaDict, setDetailedCriteriaDict] = useState<Option[]>([]);
    const mainCriteriaDict = GetOptions("KRYT_WYZN_TZ_GLOWNE_ID", krForm.dictionaries, true);
    const [tableError, setTableError] = useState<boolean>(false);
    const [tableErrorMsg, setTableErrorMsg] = useState<string>('');
    const [mainError, setMainError] = useState<boolean>(false);
    const [reasonError, setReasonError] = useState<boolean>(false);
    const [isDetailed, setIsDetailed] = useState<boolean>(true);
    const [isReason, setIsReason] = useState<boolean>(true);
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            var errorMsg = krForm.config?.ValidationError!["designationCriteria"]
            if (errorMsg !== '') {
                setTableError(true);
                setTableErrorMsg(errorMsg);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const onClickBtn = () => {
        setIsForm(true);
    }

    const addCriterion = (e: any) => {
        const isReasonValid = criterionRocord.uzasadnienie !== null && criterionRocord.uzasadnienie !== undefined && criterionRocord.uzasadnienie !== '';
        setMainError(criterionRocord.kryT_WYZN_TZ_GLOWNE_ID === null);
        setReasonError(!isReasonValid);
        if (criterionRocord.kryT_WYZN_TZ_GLOWNE_ID === null || !isReasonValid) {
            return;
        }
        let form = structuredClone(krForm);
        if(!form?.designationCriteria){
            form.designationCriteria = [];
        }
        if (form?.designationCriteria) {
            const hasTheSameMainCriterion = form.designationCriteria.some((criterion) => {
                return criterion.kryT_WYZN_TZ_GLOWNE_ID === criterionRocord.kryT_WYZN_TZ_GLOWNE_ID;
            });
            if (hasTheSameMainCriterion) {
                const mainCriterionName = decodeValue(mainCriteriaDict, criterionRocord.kryT_WYZN_TZ_GLOWNE_ID as number);
                notifyWarn({ message: `Kryterium główne '${mainCriterionName}' już istnieje w tabeli, nie można dodać rekordu.` });
            } else {
                let newCriterion = Object.assign({}, criterionRocord);
                let newForm = { ...krForm, designationCriteria: [...form.designationCriteria, newCriterion] };
                setkrForm(newForm);

                if (tableError) {
                    refreshValidation(newForm.designationCriteria);
                }

                setSelectedDetailed(undefined);
                setCriterionRocord(defaultCriterion);
                setDetailedCriteriaDict([]);
                setIsReason(false);
            }
        }
    }

    const refreshValidation = (values: EndangeredAreaDesignationCriteria[]) => {
        if (props.collectiveEdition) return;
        const currValidation = createConfigValidation("designationCriteria", false);
        const currValidationMsg = validation(currValidation, values);
        if (currValidationMsg) {
            setTableError(true);
            setTableErrorMsg(currValidationMsg);
        } else {
            setTableError(false);
            setTableErrorMsg('');
        }
    }

    const getBtnProps = (title: string, callback: any, className: string): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: (e: any) => { callback(e) },
                style: { width: '100%' },
                className: className,
                disabled: !props.editMode
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: addCircleIcon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: '49%',
                    paddingBottom: '10px'
                }
            }
        };
    }

    const handleDeleteClick = (row: TableRecord) => {
        setTableRow(row);
        setConfirmation(true);
    }

    const deleteCriterion = (row: TableRecord) => {
        if (krForm?.designationCriteria) {
            const newCriteria = krForm.designationCriteria.filter((item) => {
                return item.kryT_WYZN_TZ_GLOWNE_ID !== Number(row.itemGlobalId);
            });
            setkrForm({ ...krForm, designationCriteria: newCriteria });
            refreshValidation(newCriteria);
        }
    }

    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"universal-edit"}
            deleteClickHandler={handleDeleteClick}
            editClickHandler={handleEditClick}
            closeClickHandler={handleCloseClick}
            visibilityRows={visibilityRows}
            draggableStyle={props.editMode}
            addCommentBtnVisible={!props.editMode}
            addCommentBtnClickHandler={handleAddCommentClick}
            addCommentBtnRef={getAddCommentBtnRef}
            checkIfMarkedForCommentFilter={checkIfRowMarkedForCommentFilter}
        />)
    }

    const checkIfRowMarkedForCommentFilter = (row: any) => {
        if (props.markedFieldForCommentFiltering) {
            return checkIfMarkedForCommentFilter(KRTZFieldDict.glKryt_kryterium, row.itemGlobalId, props.markedFieldForCommentFiltering)
        }
    }

    const handleEditClick = (row: TableRecord) => {
        const strId = getRowId(row);
        setRowsToFoldOut([...rowsToFoldOut, strId]);
        setVisibilityRows([...visibilityRows, strId]);
    }

    const handleCloseClick = (row: TableRecord) => {
        const strId = getRowId(row);
        setRowsToFoldOut(rowsToFoldOut.filter((item) => {
            return item !== strId;
        }));
        setVisibilityRows(visibilityRows.filter((item) => {
            return item !== strId;
        }));
    }

    const handleAddCommentClick = (row: any) => {
        fireAddCommentBtnOnClickForRow(KRTZFieldDict.glKryt_kryterium, row.itemGlobalId,
            `Wiersz sekcji: ${props.version === PatternType.P2007 ? 'Główne kryteria wyznaczenia terenu' : 'Główne kryterium wyznaczenia terenu'}`,
            props.setNewCommentFieldDetails!);
    }

    const getAddCommentBtnRef = (node: any, row: any) => {
        getFieldRefForRow(node, KRTZFieldDict.glKryt_kryterium, row.itemGlobalId, props.getMapForComment!);
    }

    const getRowId = (row: TableRecord) => {
        return row.itemGlobalId as string;
    }

    const headers = {
        main: "Kryterium główne",
        reason: "Uzasadnienie"
    };

    const createTableList = () => {
        let records: TableRecord[] = [];
        if (krForm.designationCriteria && krForm.designationCriteria.length > 0) {
            for (var i = 0; i < krForm.designationCriteria.length; i++) {
                const criterion = krForm.designationCriteria[i];
                const mainId = criterion.kryT_WYZN_TZ_GLOWNE_ID as number;
                let record: TableRecord = {
                    itemGlobalId: mainId.toString(),
                    main: decodeValue(mainCriteriaDict, mainId),
                    reason: criterion.uzasadnienie ? criterion.uzasadnienie : ''
                };
                records.push(record);
            }
        }
        return records;
    }

    const decodeValue = (dict: Option[] | undefined, value: number) => {
        if (dict) {
            const dictItem = dict.find(d => d.value === value);
            if (dictItem) {
                return dictItem.name;
            }
        }
        return value?.toString();
    }

    const prepareDetailedDict = (value: number) => {
        let dict = krForm.dicts?.detailedDesignationCriteriaDict;
        if (dict) {
            return dict.filter(d => d.kryT_WYZN_TZ_GLOWNE_ID === value)
                .sort((a, b) => a.kolejnosc! - b.kolejnosc!)
                .map(d => {
                    return { name: d.wartosc, value: d.id }
                });
        }

        let dictLocal = krForm.dictionaries!["DICT_KRYT_WYZN_TZ_SZCZEGOLOWE"].map((element: Option) => {
            return element.anothers as any;
        });
        if (dictLocal) {
            return dictLocal.filter(d => d.KRYT_WYZN_TZ_GLOWNE_ID === value)
                .sort((a, b) => a.KOLEJNOSC! - b.KOLEJNOSC!)
                .map(d => {
                    return { name: d.WARTOSC, value: d.ID }
                });
        }
        return [];
    }

    const prepareFoldoutContent = (row: TableRecord) => {
        const saveDescription = (value: string) => {
            if (krForm?.designationCriteria) {
                const rowId = Number(row.itemGlobalId);
                const newCriteria = krForm.designationCriteria.map((current: any) => ({
                    ...current,
                    uzasadnienie: current.kryT_WYZN_TZ_GLOWNE_ID === rowId ? value : current.uzasadnienie
                }));
                setkrForm({ ...krForm, designationCriteria: newCriteria });
                refreshValidation(newCriteria);
            }
            handleCloseClick(row);
        }

        return (
            <TableTextEditRow
                value={row.reason ? row.reason : ''}
                placeholder={"Podaj uzasadnienie"}
                btnTitle={"Zapisz uzasadnienie"}
                onSave={saveDescription}
            />
        )
    }

    let cellWidth = {
        main: '140px'
    }

    var tableProps: TableProps = {
        columnAliases: headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: Object.keys(headers),
        cellActions: cellAction,
        data: createTableList(),
        loading: false,
        className: "fileTable",
        cellWidth: cellWidth,
        draggableRows: props.editMode,
        foldoutRows: true,
        rowsToFoldOut: rowsToFoldOut,
        foldoutContent: prepareFoldoutContent,
        foldoutParamToCheck: getRowId,
        tableError: tableError,
        tableErrorMsg: tableErrorMsg,
        setCommentsFilter: (row: any) => { if (props.setCommentsFilter) props.setCommentsFilter(getKRDictFieldNameForRow(KRTZFieldDict.glKryt_kryterium, row.itemGlobalId)); },
        checkIfMarkedForCommentFilter: (row: any) => { checkIfRowMarkedForCommentFilter(row) },
        narrowTableForCommentBtns: !props.editMode,
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    const confirm = () => {
        setConfirmation(false);
        if (tableRow) { deleteCriterion(tableRow); }
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz usunąć kryterium?`;
    }

    const mainCriterionOnChange = (opt: Option[]) => {
        setMainError(false);
        setReasonError(false);
        if (opt.length === 1) {
            const mainId = opt[0].value as number;
            const newCriterion: EndangeredAreaDesignationCriteria = {
                kryT_WYZN_TZ_GLOWNE_ID: mainId,
                kryT_WYZN_TZ_SZCZEGOLOWE_ID: null,
                uzasadnienie: criterionRocord.uzasadnienie,
                tereN_ZAGROZONY_GID: krForm.endangeredAreaAttributes?.globalid as string
            };
            const newDetailedDict = prepareDetailedDict(mainId);
            setDetailedCriteriaDict(newDetailedDict);
            setCriterionRocord(newCriterion);
        } else {
            setDetailedCriteriaDict([]);
            setCriterionRocord({ ...defaultCriterion, uzasadnienie: criterionRocord.uzasadnienie });
        }
        setSelectedDetailed(undefined);
        setIsDetailed(false);
    }

    const onDetailedClick = () => {
        const detailedValue = selectedDetailed?.name ? selectedDetailed.name : '';
        if (detailedValue) {
            const reason = criterionRocord.uzasadnienie ? criterionRocord.uzasadnienie : '';
            const newValue = `${reason}${detailedValue}`;
            setCriterionRocord({ ...criterionRocord, uzasadnienie: newValue });
            setReasonError(false);
        }
    }

    const detailedCriterionOnChange = (option: Option | Option[]) => {
        if (option) {
            const opt = option as Option;
            if (opt.name) {
                setSelectedDetailed(opt);
            }
        }
    }

    const selectForTextProps: SelectForTextFieldProps = {
        selectInputProps: {
            style: stylizationWrapper,
            label: 'Kryterium szczegółowe',
            options: detailedCriteriaDict,
            selectedSingleOption: selectedDetailed,
            disabled: detailedCriteriaDict.length === 0,
            onChange: detailedCriterionOnChange
        },
        buttonProps: {
            BtnProps: {
                onClick: onDetailedClick,
                className: classNameBtn.SmallSecondary + " body-txt-medium",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%'
                }
            },
            placeHolder: "Dodaj",
            placeHolderStyle: {
                paddingLeft: '25px'
            },
            additionalIcon: addCircleIcon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: 'auto',
                    display: 'flex',
                    height: '49px',
                    paddingTop: '30.5px'
                }
            }
        }
    }

    var textAreaProps: TextAreaFieldProps = {
        labelName: 'Uzasadnienie',
        textAreaPlaceholder: 'Uzasadnienie',
        value: criterionRocord.uzasadnienie ? criterionRocord.uzasadnienie : undefined,
        textareaSharedProps: {
            className: 'body-txt-large',
            style: {
                width: '100%',
                minHeight: '70px'
            }
        },
        disabled: !props.editMode,
        pristine: true,
        setValue: (value: any) => {
            setCriterionRocord({ ...criterionRocord, uzasadnienie: value });
            if (reasonError) { setReasonError(false); }
        },
        configValidation: createConfigValidation("onlyRequired"),
        validationError: reasonError,
        dynamicResize: true
    }

    useEffect(() => {
        if (isDetailed === false) {
            setIsDetailed(true);
        }
    }, [isDetailed])

    useEffect(() => {
        if (isReason === false) {
            setIsReason(true);
        }
    }, [isReason])

    const renderForm = () => {
        return isForm ? <>
            {!props.collectiveEdition && <div style={styleFormFieldHalf}></div>}
            {isReason && <SelectInput style={styleFormFieldHalf} label="Kryterium główne"
                hasInputTags={true} options={mainCriteriaDict} onlySingleTag={true} enableClean={true} onChange={mainCriterionOnChange}
                configValidation={createConfigValidation("onlyRequired")} validationError={mainError} />}
            <div className='form-half-template' style={styleFormFieldHalf}> {isDetailed && <SelectForTextField {...selectForTextProps} />}</div>
            {isReason && <TextAreaField {...textAreaProps} />}
            <div style={styleFormFieldHalf}></div>
            <ButtonField {...getBtnProps("Dodaj kryterium", addCriterion, classNameBtn.Small)} />
        </> :
            null
    }

    const getSectionHeading = () => {
        if (props.version === PatternType.P2007) return "2. Główne kryteria wyznaczenia terenu";
        else if (props.version === PatternType.P2020) return "3. Główne kryterium wyznaczenia terenu";
        else return "";
    }

    return (
        <>
            <div ref={(node: any) => {if (!props.collectiveEdition) getFieldRef(node, KRTZFieldDict.glKryt_sekcja, props.getMapForComment!)}} style={{width: "100%"}}></div>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKRTZEum.MainCriterionForArea, props.getMapForNavScroll!)}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KRTZFieldDict.glKryt_sekcja); }}
                style={{ width: '100%' }}>{getSectionHeading()}</h2>
            {!props.editMode && renderSectionCommentBtn(props.markedFieldForCommentFiltering === KRTZFieldDict.glKryt_sekcja, false, getSectionHeading(), props.setNewCommentFieldDetails!, KRTZFieldDict.glKryt_sekcja)}
            {(props.editMode || props.collectiveEdition) &&
                <>
                    {props.collectiveEdition ?
                        <div className="collective-input-container">
                            <h3 style={{ width: '100%' }} className='collective-section'>Dodaj kryterium <CollectiveLabelChip isAuto={false} /></h3>
                        </div> : <h3 style={{ width: '100%' }}>Dodaj kryterium</h3>
                    }
                    <ButtonField {...getBtnProps("Dodaj kryterium", onClickBtn, classNameBtn.Big + " body-txt-large")} />
                </>
            }
            {props.collectiveEdition ? <div className='collective-block collective-block-genesis'>{renderForm()}</div> : renderForm()}
            {props.collectiveEdition ? <CollectiveSelectField top={false} value={(krForm as KrEndangeredAreaFormTypes).designationCriteria} title={"Główne kryterium wyznaczenia terenu"}
                forms={props.forms} keyName={CollectivePreviewKey.glowneKryterium} actions={props.actions} single={false}
                dics={{ "mainDict": mainCriteriaDict }}
                setActions={props.setActions} onDelete={props.onDelete}>
                <div style={{ width: '100%' }}><Table {...tableProps} /></div>
            </CollectiveSelectField> :
                <Table {...tableProps} />
            }
            {confirmation &&
                <ConfirmModal width={"660px"} height={"auto"}
                    confirmTitle={"Tak, usuń kryterium"}
                    onConfirm={confirm}
                    cancelTitle={"Anuluj"}
                    onCancel={cancel}
                    question={getQuestion()}
                    refocus={refocus}
                />}
        </>
    )
}

export default MainCriterionForArea;